import React from 'react';
import { GetClinicWidgetRequestQuery, Maybe, WidgetRequestType } from 'shared/types/graphql';
import { Answers } from './Answers';
import { MultiPetAnswers } from './MultiPetAnswers';
import { RequestFormInput } from './types';

type WidgetRequestAnswerSummaryProps = {
  widgetRequestData?: GetClinicWidgetRequestQuery;
  primaryPhoneNumber: Maybe<string>;
  small?: boolean;
  showNewClientTag?: boolean;
  borderLeftColor?: string;
};

export const WidgetRequestAnswerSummary = ({
  primaryPhoneNumber,
  widgetRequestData,
  small,
  borderLeftColor,
  showNewClientTag,
}: WidgetRequestAnswerSummaryProps): JSX.Element => {
  const requestType = widgetRequestData?.clinicWidgetRequest?.clinicWidgetRequestType;
  // The nested FormSubmission is the preferred source of truth, but older ClinicWidgetRequests
  // and Direct Booking requests don't include a related FormSubmission record
  const formContent =
    widgetRequestData?.clinicWidgetRequest?.formSubmission?.completedContent ||
    widgetRequestData?.clinicWidgetRequest?.requestFormSubmission;

  const parsedFormContent = typeof formContent === 'string' ? JSON.parse(formContent) : formContent;
  const formQuestionAnswers = parsedFormContent?.questions as RequestFormInput[];

  return requestType?.requestType === WidgetRequestType.AdvancedRequestRxRefill ? (
    <MultiPetAnswers
      parsedFormContent={parsedFormContent}
      primaryPhoneNumber={primaryPhoneNumber}
      small={small}
      borderLeftColor={borderLeftColor}
      showNewClientTag={showNewClientTag}
    />
  ) : (
    <Answers
      formQuestionAnswers={formQuestionAnswers}
      primaryPhoneNumber={primaryPhoneNumber}
      small={small}
      borderLeftColor={borderLeftColor}
      showNewClientTag={showNewClientTag}
      clinicWidgetRequestId={widgetRequestData?.clinicWidgetRequest?.id}
    />
  );
};
